import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GrantEmploymentDialogComponent } from '../../../home/components/dialogs/grant-employment-dialog/grant-employment-dialog.component';

/**
 * Componente footer.
 */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  constructor(
    private dialog: MatDialog
  ) { }

  openGrantDialog() {
    this.dialog.open(GrantEmploymentDialogComponent, {
      disableClose: true,
      maxWidth: '100vw',
      panelClass: 'grant-employment-dialog',
    });
  }
}
